function hslToHex(h: number, s: number, l: number) {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0'); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`.toUpperCase();
}

export const convertToHex = (value: string) => {
  if (value.includes('calc')) {
    const content = /calc\((.*?)\)/g.exec(value);
    if (!content) return value;
    const [left, op, right] = content[1].replace(/%/g, '').split(' ');
    const result = parseInt(left) + (op === '+' ? 1 : -1) * parseInt(right);
    value = value.replace(/calc\((.*?)\)/g, result + '%');
  }
  const [h, s, l] = value.split(',').map((x) => parseFloat(x.replace(/[^0-9.]/g, '')));
  return hslToHex(h, s, l);
};
